import toast from 'react-hot-toast';

const COLORS = {
  maroon: '#7B1F2E',
  border: '#E5DBD2',
  textPrimary: '#2D2A2E',
};

const baseStyle = {
  fontFamily: 'inherit',
  fontSize: '14px',
  fontWeight: 500,
  borderRadius: '10px',
  border: `1px solid ${COLORS.border}`,
  padding: '12px 16px',
  color: COLORS.textPrimary,
  boxShadow: '0 8px 24px rgba(45,42,46,0.08)',
  maxWidth: '420px',
};

export const notify = {
  success: (message, opts = {}) =>
    toast.success(message, {
      duration: 3000,
      style: { ...baseStyle, background: '#F0FDF4', borderColor: '#86EFAC' },
      iconTheme: { primary: '#15803D', secondary: '#F0FDF4' },
      ...opts,
    }),

  error: (message, opts = {}) =>
    toast.error(message, {
      duration: 5000,
      style: { ...baseStyle, background: '#FEF2F2', borderColor: '#FCA5A5' },
      iconTheme: { primary: COLORS.maroon, secondary: '#FEF2F2' },
      ...opts,
    }),

  info: (message, opts = {}) =>
    toast(message, {
      duration: 3500,
      style: { ...baseStyle, background: '#EFF6FF', borderColor: '#BFDBFE' },
      icon: 'ℹ️',
      ...opts,
    }),

  loading: (message, opts = {}) =>
    toast.loading(message, {
      style: { ...baseStyle, background: '#FAF7F2' },
      ...opts,
    }),

  promise: (promise, msgs, opts = {}) =>
    toast.promise(
      promise,
      {
        loading: msgs.loading || 'Working…',
        success: msgs.success || 'Done',
        error: (err) => msgs.error || (typeof err === 'string' ? err : err?.message || 'Failed'),
      },
      {
        style: baseStyle,
        success: { duration: 3000, iconTheme: { primary: '#15803D', secondary: '#F0FDF4' } },
        error: { duration: 5000, iconTheme: { primary: COLORS.maroon, secondary: '#FEF2F2' } },
        ...opts,
      }
    ),

  dismiss: (id) => toast.dismiss(id),
};

export default notify;
